var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLineDownGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.967 25.977L1.968 0H.032L.031 25.979z",
    fill: "#8C8C8C",
    fillRule: "nonzero"
  })));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMnB4IiBoZWlnaHQ9IjI2cHgiIHZpZXdCb3g9IjAgMCAyIDI2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHRpdGxlPlBhdGg8L3RpdGxlPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9ImFycm93LWRvd24tZ3JheSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMzEwMDAsIDAuMDAwMDAwKSIgZmlsbD0iIzhDOEM4QyIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlBhdGgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuOTY4NTAwLCAxMi45ODk1MDApIHNjYWxlKC0xLCAxKSByb3RhdGUoOTAuMDAwMDAwKSB0cmFuc2xhdGUoLTAuOTY4NTAwLCAtMTIuOTg5NTAwKSAiIHBvaW50cz0iMTMuOTU2IDEzLjk1NyAtMTIuMDIxIDEzLjk1OCAtMTIuMDIxIDEyLjAyMiAxMy45NTggMTIuMDIxIj48L3BvbHlnb24+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
export { SvgLineDownGray as ReactComponent };